<template>
  <div class="main-container">
    <CertificationBanner />
    <CertificationIntro />
    <CertificationCourses />
    <CertificationForm />
  </div>
</template>

<script>
import { useMeta } from 'vue-meta';
import CertificationBanner from '@/components/certification/CertificationBanner';
import CertificationIntro from '@/components/certification/CertificationIntro';
import CertificationCourses from '@/components/certification/CertificationCourses';
import CertificationForm from '@/components/certification/CertificationForm';

export default {
  name: 'CertificationView',
  components: {
    CertificationBanner,
    CertificationIntro,
    CertificationCourses,
    CertificationForm,
  },
  beforeMount() {
    useMeta({
      title: this.$t('pagenames.certification') + ' | AI gym',
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
    });
  },
};
</script>
